import React from 'react';
import Route from 'found/lib/Route';
import { graphql } from 'react-relay';
import { Loader } from '../components/Elements';
import TemplateListContainer from '../components/Document/Template/TemplateListContainer';

const TemplateListRoute = (
  <Route
    path='templates'
    Component={TemplateListContainer}
    query={graphql`
      query TemplateListRoute_TemplateList_Query {
        viewer {
          ...TemplateListContainer_viewer
        }
      }
    `}
    render={({ props }) =>
      (props ? <TemplateListContainer {...props} /> : <Loader />)}
  />
);

export default TemplateListRoute;



// WEBPACK FOOTER //
// ./webpack/routes/_TemplateListRoute.js